import React, { useEffect, useState } from 'react';

import { useLazyGetQuickSlotQuery } from 'features/api/apiSlice';
import { isTruthy } from 'utility/functions';

import { Wrapper } from 'components/wrapper';
import styles from './QuickSlot.module.scss';
import { QuickSlotCard } from 'components/quickSlot/quickSlotCard';
import useWindowSize from 'hooks/useWindowSize';
import { isServerSide } from 'utility/constant';
import { useRouter } from 'next/router';

export type QuickSlotProps = {
  title: string;
  isCover?: boolean;
  subtitle: string;
};

export const QuickSlot = ({ title, subtitle, isCover }: QuickSlotProps) => {
  const [getQuickSlots, { data }] = useLazyGetQuickSlotQuery();

  const { asPath } = useRouter();
  const { isMobile } = useWindowSize();

  const [activeCardId, setActiveCardId] = useState<string | null>(null);

  useEffect(() => {
    if (isServerSide) return;
    getQuickSlots();
  }, [asPath, getQuickSlots]);

  if (isTruthy(data?.games?.length)) {
    return (
      <Wrapper bgColorTransparent noPaddingRight={isMobile} noPaddingLeft>
        <div className={styles.container}>
          <div className={styles.heading}>
            <h2 className={styles.headingTitle}>{title}</h2>
            {subtitle && <p className={styles.headingSubtitle}>{subtitle}</p>}
          </div>
          <article className={styles.cardsContainer}>
            {data?.games?.map((card, index: number) => {
              if (index < 6)
                return (
                  // TODO: Fixare le prop mancanti
                  // @ts-ignore
                  <QuickSlotCard
                    key={card.id}
                    {...card}
                    setActiveCardId={setActiveCardId}
                    activeCardId={activeCardId}
                    isCover={isCover || false}
                  />
                );
              else {
                return;
              }
            })}
          </article>
        </div>
      </Wrapper>
    );
  }

  return <React.Fragment key={'Quick-Slot-null'} />;
};